import type { Resource } from '../types/content'

export const mainGuide: Resource = {
  id: 'guide',
  kind: 'guide',
  name: 'Le guide L’Atelier du Faux Vitrail',
  benefit: 'Apprendre la technique depuis le début',
  description:
    'De la préparation du support aux finitions : tracer des contours réguliers, appliquer la couleur, respecter le séchage propre à vos produits et éviter les erreurs les plus fréquentes.',
  image:
    'https://cdn.magicpatterns.com/uploads/3HsGdNANsfTozk1cmMq2oh/MOCK_UP_PRINCIPAL.png',
  imageAlt:
    'Couverture du guide L’Atelier du Faux Vitrail, ornée d’un colibri multicolore',
}

export const bonuses: Resource[] = [
  {
    id: 'materiel',
    kind: 'bonus',
    number: 1,
    name: 'Bien choisir son matériel',
    benefit: 'Vous équiper sans hésiter',
    description:
      'Pour repérer les peintures, cernes et supports compatibles entre eux, et installer un espace de travail pratique avant votre première séance.',
    image:
      'https://cdn.magicpatterns.com/uploads/aMpeaZX8DZ4x1NudqBxK1i/Guia_de_materiales_para_falso_vitral.png',
    imageAlt:
      'Livre Bien choisir son matériel posé sur un tissu, avec des pots de peinture et une petite plaque fleurie',
  },
  {
    id: 'modeles-tracer',
    kind: 'bonus',
    number: 2,
    name: 'Mes modèles à tracer',
    benefit: 'Gagner en assurance au trait',
    description:
      'Des modèles simples pour vous exercer aux lignes, aux courbes et aux contours fermés avant de passer à la couleur.',
    image:
      'https://cdn.magicpatterns.com/uploads/ikfmgdJpWbL6WBrvts3TN3/Plantillas_iniciales.png',
    imageAlt:
      'Livre Mes modèles à tracer entouré de feuilles de motifs simples et d’une tablette affichant des dessins au trait',
  },
  {
    id: 'premieres-creations',
    kind: 'bonus',
    number: 3,
    name: 'Mes Premières Créations',
    benefit: 'Appliquer la technique pas à pas',
    description:
      'Six projets guidés, du plus simple au plus détaillé, pour mettre en pratique ce que vous apprenez dans le guide.',
    image:
      'https://cdn.magicpatterns.com/uploads/nBMstk4atonQF1Vc6sS2Rk/Creatividad_francesa_con_vitral_floral.png',
    imageAlt:
      'Une femme dans un atelier lumineux tient une plaque fleurie en faux vitrail, à côté du livre Mes Premières Créations',
  },
  {
    id: 'couleurs',
    kind: 'bonus',
    number: 4,
    name: 'Mon Carnet de Couleurs',
    benefit: 'Composer des harmonies de couleurs',
    description:
      'Douze palettes pour vous aider à choisir vos teintes et à les répartir harmonieusement sur un motif.',
    image:
      'https://cdn.magicpatterns.com/uploads/heocJRu634NRtQmevogZDM/Cuaderno_de_colores_y_vidrios.png',
    imageAlt:
      'Livre Mon Carnet de Couleurs à côté d’une rangée de carrés de verre colorés',
  },
]

export const templateLibrary: Resource = {
  id: 'bibliotheque',
  kind: 'bonus',
  number: 5,
  name: '100+ modèles de faux vitrail',
  benefit: 'Choisir votre prochaine création',
  description:
    'Une bibliothèque de plus de 100 modèles variés à tracer, pour continuer à créer après vos premiers exercices.',
  image:
    'https://cdn.magicpatterns.com/uploads/tbDvhPafAvBJL4GS17dzNF/Mas_de_100_disenos_de_falso_vitral.png',
  imageAlt:
    'Livre 100+ modèles de faux vitrail posé sur de nombreuses feuilles de motifs détaillés : fleurs, oiseaux, papillon, soleil',
}

export const allResources: Resource[] = [mainGuide, ...bonuses, templateLibrary]
